import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, IconButton } from '@mui/material';
import type { BaseSyntheticEvent } from 'react';
import type React from 'react';

interface IProps {
  className?: string;
  children?: React.ReactNode;
  onClose: (event: BaseSyntheticEvent) => void;
  closeDisabled?: boolean;
}
const FuelDialogHeader = (props: IProps) => {
  let { className, children, onClose, closeDisabled, ...other } = props;

  if (closeDisabled == null) {
    closeDisabled = false;
  }

  return (
    <DialogTitle className={className} sx={{ m: 0, p: 2 }} {...other}>
      <div style={{ paddingRight: '44px' }}>{children}</div>
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          disabled={closeDisabled}
          sx={{
            position: 'absolute',
            right: 8,
            top: 0,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export default FuelDialogHeader;
